import { render, staticRenderFns } from "./AssetLeak.vue?vue&type=template&id=6773b0e5&"
import script from "./AssetLeak.vue?vue&type=script&lang=js&"
export * from "./AssetLeak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports